import React from 'react'

const TermPage = () => {
    return (
        <div className="page-container">
            <div className="content-card">
                <span className="privacy-badge">User Agreement</span>
                <h1>Terms & Conditions</h1>
                <p className="last-updated">Last updated: May 19, 2026</p>
                
                <p>
                    Please read these Terms & Conditions ("Terms") carefully before using our mobile applications ("the Application" or "the Service") operated by Widgets ("the Company", "We", "Us", or "Our").
                </p>

                <p>
                    By downloading, installing, or using the Application, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access or use the Service.
                </p>

                <h1>1. Eligibility</h1>
                <p>
                    By using the Service, you represent and warrant that you are at least 13 years of age. If you are under the age of 18, you may use the Service only with the consent and supervision of a parent or legal guardian.
                </p>

                <h1>2. User License</h1>
                <p>
                    We grant you a limited, non-exclusive, non-transferable, revocable license to download, install, and use the Application on your personal mobile device strictly in accordance with these Terms. You shall not:
                </p>
                <ul>
                    <li>Decompile, reverse engineer, disassemble, or attempt to derive the source code of the Application.</li>
                    <li>Modify, adapt, improve, translate, or create derivative works from the Application.</li>
                    <li>Distribute, rent, lease, lend, sublicense, or otherwise transfer the Application to any third party.</li>
                    <li>Remove, alter, or obscure any proprietary notice (including copyright or trademark notices) of the Company.</li>
                </ul>

                <h1>3. In-App Purchases & Subscriptions</h1>
                <p>
                    Certain features of the Application may require payment, including one-time purchases or auto-renewing subscriptions.
                </p>
                <ul>
                    <li><strong>Billing:</strong> All transactions are conducted through the Apple App Store or Google Play Store ("Application Store"). You agree to pay all fees incurred through your account at the prices in effect when such charges are incurred.</li>
                    <li><strong>Subscriptions:</strong> Subscriptions automatically renew unless auto-renew is turned off at least 24 hours before the end of the current billing cycle. You can manage or cancel your subscriptions directly in your Google Play or App Store account settings.</li>
                    <li><strong>Refunds:</strong> All refund requests are handled directly by the respective Application Store in accordance with their refund policies. The Company does not process refunds directly.</li>
                </ul>

                <h1>4. Intellectual Property Rights</h1>
                <p>
                    The Application, including its original designs, widgets, layouts, wallpapers, logo, code, and graphics, is the exclusive property of Widgets and is protected by copyright, trademark, and other intellectual property laws. You agree not to copy, scrape, or distribute any proprietary widget designs or resources without our express written consent.
                </p>

                <h1>5. Third-Party Services</h1>
                <p>
                    The Application may contain links or display content from third-party services (such as Firebase, Google Play Services, etc.). We do not control or assume responsibility for the content, privacy policies, or practices of any third-party websites or services. You acknowledge that we are not liable for any issues arising from your use of third-party platforms.
                </p>

                <h1>6. Limitation of Liability</h1>
                <p>
                    To the maximum extent permitted by applicable law, in no event shall Widgets or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data, business interruption, or personal injury) arising out of or in any way related to the use of or inability to use the Service.
                </p>
                <p>
                    Our total liability for any claim under these Terms shall not exceed the amount actually paid by you through the Service, or 10 USD if you have not purchased anything.
                </p>

                <h1>7. "AS IS" Disclaimer</h1>
                <p>
                    The Service is provided to you "AS IS" and "AS AVAILABLE" with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company disclaims all warranties, whether express, implied, statutory, or otherwise, including all implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the Service will meet your requirements, operate without interruption, or be completely error-free.
                </p>

                <h1>8. Governing Law & Dispute Resolution</h1>
                <p>
                    These Terms and your use of the Service shall be governed by the laws of Maharashtra, India, excluding its conflicts of law rules. Any dispute arising under these Terms shall first be attempted to be resolved informally by contacting us.
                </p>

                <h1>9. Changes to These Terms</h1>
                <p>
                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide notice by posting the updated Terms on this page. By continuing to use the Service after those revisions become effective, you agree to be bound by the modified terms.
                </p>

                <h1>10. Contact Us</h1>
                <p>
                    If you have any questions or concerns about these Terms & Conditions, please contact us:
                </p>
                <ul>
                    <li>By email: <a href="mailto:ganeshglive@gmail.com">ganeshglive@gmail.com</a></li>
                </ul>
            </div>
        </div>
    )
}

export default TermPage